import { Cloud } from '@silbo/core';
import { queryOptions } from '@tanstack/react-query';
import { datadogLogs } from '@datadog/browser-logs';

export const getDailyFaresQueryOptions = () => {
  return queryOptions({
    queryKey: ['getDailyFares'],
    queryFn: () => {
      datadogLogs.logger.debug('TANSTACK_DEBUG: TanStack Query executing getDailyFares query', {
        queryKey: ['getDailyFares'],
        timestamp: Date.now(),
        source: 'tanstack-query-refetch',
      });
      return Cloud.getPorterDailyFares();
    },
    refetchOnWindowFocus: 'always',
    refetchOnReconnect: 'always',
  });
};
